import axios from "axios";
import accessToken from "../jwt-token-access/accessToken";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
const API_NOTES_URL = process.env.REACT_APP_ACADEMIC_MANAGEMENT_SERVICE_URL;
const axiosApi = axios.create({
  baseURL: API_NOTES_URL,
  headers: { 
    'Content-Type': 'application/json',
    'Accept': 'application/json' 
  }
});

axiosApi.defaults.headers.common["Authorization"] = token;
//axios.defaults.baseURL = API_SERIES_URL;

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function patch(url, data, config = {}) {
  return axiosApi
    .patch(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}
